
declare global {
  interface Window {
    proxy: string,
    get_token: string,
  }
}

export type APIValue<T> = [{
  code: number,
  error?: {
    detail: string,
    rspCode: number,
  },
  value: T,
  initial?: T,
  range?: T,
}];

export type PtzPosition = {
  channel: number,
  enable: 0 | 1,
  id: number,
  name: string,
};

export type PtzPreset = {
  PtzPreset: PtzPosition[],
};

type ZoomValue = {
  pos: number,
};
export type ZoomFocus = {
  ZoomFocus: {
    channel: number,
    zoom: ZoomValue,
    focus: ZoomValue,
  },
};

type Sens = {
  beginHour: number,
  beginMin: number,
  enable: number,
  endHour: number,
  endMin: number,
  id: number,
  priority: number,
  sensitivity: number,
};
export type MdAlarm = {
  MdAlarm: {
    channel: number,
    newSens: {
      sens: Sens[],
      sensDef: number,
    },
    scope: {
      cols: number,
      rows: number,
      table: string,
    },
    sens: Omit<Sens, 'priority' | 'enable'>[],
    useNewSens: number,
  },
};
type AiAlarm = {
  ai_detect_type: string,
  height: number,
  max_target_height: number,
  max_target_width: number,
  min_target_height: number,
  min_target_width: number,
  scope: {
    area: string,
  },
  sensitivity: number,
  stay_time: number,
  width: number,
};

type _Ability = { permit: number, ver: number };
type ChannelAbility = {
  aiTrack: _Ability,
  aiTrackDogCat: _Ability,
  alarmAudio: _Ability,
  alarmIoIn: _Ability,
  alarmIoOut: _Ability,
  alarmMd: _Ability,
  alarmRf: _Ability,
  batAnalysis: _Ability,
  battery: _Ability,
  cameraMode: _Ability,
  disableAutoFocus: _Ability,
  enc: _Ability,
  floodLight: _Ability,
  ftp: _Ability,
  image: _Ability,
  indicatorLight: _Ability,
  isp: _Ability,
  isp3Dnr: _Ability,
  ispAntiFlick: _Ability,
  ispBackLight: _Ability,
  ispBright: _Ability,
  ispContrast: _Ability,
  ispDayNight: _Ability,
  ispExposureMode: _Ability,
  ispFlip: _Ability,
  ispHue: _Ability,
  ispMirror: _Ability,
  ispSatruation: _Ability,
  ispSharpen: _Ability,
  ispWhiteBalance: _Ability,
  ledControl: _Ability,
  live: _Ability,
  mainEncType: _Ability,
  mask: _Ability,
  mdTriggerAudio: _Ability,
  mdTriggerRecord: _Ability,
  mdWithPir: _Ability,
  osd: _Ability,
  powerLed: _Ability,
  ptzCtrl: _Ability,
  ptzDirection: _Ability,
  ptzPatrol: _Ability,
  ptzPreset: _Ability,
  ptzTattern: _Ability,
  ptzType: _Ability,
  recCfg: _Ability,
  recDownload: _Ability,
  recReplay: _Ability,
  recSchedule: _Ability,
  shelterCfg: _Ability,
  snap: _Ability,
  supportAi: _Ability,
  supportAiAnimal: _Ability,
  supportAiDetectConfig: _Ability,
  supportAiDogCat: _Ability,
  supportAiFace: _Ability,
  supportAiPeople: _Ability,
  supportAiSensitivity: _Ability,
  supportAiStayTime: _Ability,
  supportAiTargetSize: _Ability,
  supportAiTrackClassify: _Ability,
  supportAiVehicle: _Ability,
  supportAoAdjust: _Ability,
  supportFLBrightness: _Ability,
  supportFLIntelligent: _Ability,
  supportFLKeepOn: _Ability,
  supportFLSchedule: _Ability,
  supportFLswitch: _Ability,
  supportGop: _Ability,
  supportMd: _Ability,
  supportPtzCalibration: _Ability,
  supportPtzCheck: _Ability,
  supportThresholdAdjust: _Ability,
  supportWhiteDark: _Ability,
  videoClip: _Ability,
  waterMark: _Ability,
  white_balance: _Ability,
};
export type Ability = {
  Ability: {
    abilityChn: ChannelAbility[],
    alarmAudio: _Ability,
    alarmDisconnet: _Ability,
    alarmHddErr: _Ability,
    alarmHddFull: _Ability,
    alarmIpConflict: _Ability,
    auth: _Ability,
    autoMaint: _Ability,
    cloudStorage: _Ability,
    customAudio: _Ability,
    dateFormat: _Ability,
    ddns: _Ability,
    ddnsCfg: _Ability,
    devInfo: _Ability,
    devName: _Ability,
    disableAutoFocus: _Ability,
    disk: _Ability,
    display: _Ability,
    email: _Ability,
    emailInterval: _Ability,
    emailSchedule: _Ability,
    exportCfg: _Ability,
    ftpAutoDir: _Ability,
    ftpExtStream: _Ability,
    ftpPic: _Ability,
    ftpSubStream: _Ability,
    ftpTest: _Ability,
    hourFmt: _Ability,
    http: _Ability,
    httpFlv: _Ability,
    https: _Ability,
    importCfg: _Ability,
    ipcManager: _Ability,
    ledControl: _Ability,
    localLink: _Ability,
    log: _Ability,
    mediaPort: _Ability,
    ntp: _Ability,
    online: _Ability,
    onvif: _Ability,
    p2p: _Ability,
    performance: _Ability,
    pppoe: _Ability,
    push: _Ability,
    pushSchedule: _Ability,
    reboot: _Ability,
    recExtensionTimeList: _Ability,
    recOverWrite: _Ability,
    recPackDuration: _Ability,
    recPreRecord: _Ability,
    restore: _Ability,
    rtmp: _Ability,
    rtsp: _Ability,
    scheduleVersion: _Ability,
    sdCard: _Ability,
    showQrCode: _Ability,
    simMoudule: _Ability,
    supportAudioAlarm: _Ability,
    supportAudioAlarmEnable: _Ability,
    supportAudioAlarmSchedule: _Ability,
    supportAudioAlarmTaskEnable: _Ability,
    supportBuzzer: _Ability,
    supportBuzzerEnable: _Ability,
    supportBuzzerTask: _Ability,
    supportBuzzerTaskEnable: _Ability,
    supportEmailEnable: _Ability,
    supportEmailTaskEnable: _Ability,
    supportFtpCoverPicture: _Ability,
    supportFtpCoverVideo: _Ability,
    supportFtpDirYM: _Ability,
    supportFtpEnable: _Ability,
    supportFtpPicCaptureMode: _Ability,
    supportFtpPicResoCustom: _Ability,
    supportFtpPictureSwap: _Ability,
    supportFtpTask: _Ability,
    supportFtpTaskEnable: _Ability,
    supportFtpVideoSwap: _Ability,
    supportFtpsEncrypt: _Ability,
    supportHttpEnable: _Ability,
    supportHttpsEnable: _Ability,
    supportOnvifEnable: _Ability,
    supportPushInterval: _Ability,
    supportRecScheduleEnable: _Ability,
    supportRecordEnable: _Ability,
    supportRtmpEnable: _Ability,
    supportRtspEnable: _Ability,
    talk: _Ability,
    time: _Ability,
    tvSystem: _Ability,
    upgrade: _Ability,
    upnp: _Ability,
    user: _Ability,
    videoClip: _Ability,
    wifi: _Ability,
    wifiTest: _Ability,
  }
};

export const createAPI = async (channel: number = 0) => {
  const tokenUrl = window.get_token.toString();
  const proxyUrl = window.proxy.toString();
  let token: string|undefined = undefined;
  let tokenPromise: Promise<string|undefined> = Promise.resolve(undefined);
  login().catch(err => (alert(err), undefined));

  function unloadHelper(e: BeforeUnloadEvent) {
    e.preventDefault();
    return (e.returnValue = "");
  }
  async function proxy(method: string) {
    const token = await login();
    const u = new URL(proxyUrl, window.location.origin);
    u.searchParams.set('token', token);
    u.searchParams.set('method', method);
    return u;
  }
  async function login(): Promise<string >{
    return tokenPromise = tokenPromise.then(() => {
      console.log('Login got previous token', token);
      if (token !== undefined) return token;
      window.removeEventListener('beforeunload', unloadHelper, { capture: true });
      window.addEventListener('beforeunload', unloadHelper, { capture: true });
      return fetch(tokenUrl).then(res => res.json()).then(res => token = res.token);
    });
  }
  async function logout(): Promise<void> {
    window.removeEventListener('beforeunload', unloadHelper, { capture: true });
    if (token === undefined) return;
    const u = new URL(proxyUrl, window.location.origin);
    u.searchParams.set('token', token);
    u.searchParams.set('method', 'Logout');
    console.log('Logoff with token', token);
    token = undefined;
    return await getValue<void>(fetch(u, {
      method: 'POST',
    }));
  }
  function logoutSync(): void {
    window.removeEventListener('beforeunload', unloadHelper, { capture: true });
    if (token === undefined) return;
    const u = new URL(proxyUrl, window.location.origin);
    u.searchParams.set('token', token);
    u.searchParams.set('method', 'Logout');
    console.log('Logoff with token', token);
    token = undefined;
    navigator.sendBeacon(u);
  }
  async function getValue<T = any>(req: Promise<Response>): Promise<T> {
    try {
      const res = await req;
      const json = await res.json() as APIValue<T>;
      if (!res.ok) throw json;
      if (json[0].code) throw json[0].error;
      return json[0].value;
    } catch (err) {
      console.error(err);
      if (err instanceof TypeError && err.message == "NetworkError when attempting to fetch resource.") throw err;
      if (JSON.stringify(err) === '{}') throw err;
      alert(JSON.stringify(err));
      throw err;
    };
  }
  async function ptzAbility() {
    console.debug('Fetching ability');
    return getValue<Ability>(fetch(await proxy('GetAbility')));
  }
  async function ptzControl(op: string, data = {}) {
    console.debug('Setting PTZ control:', op, data);
    return getValue<void>(fetch(await proxy('PtzCtrl'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "PtzCtrl", "param": {"channel": channel, "op": op, ...data}}])
    }));
  }
  async function ptzToPos(position: number) {
    console.debug('Setting position:', position);
    return getValue<void>(fetch(await proxy('ToPosition'), {
      method: 'POST',
      body: JSON.stringify(position),
    }));
  }
  async function ptzZoomFocus(op: string, val: string | number) {
    console.debug('Setting ZoomFocus:', op, val);
    return getValue<ZoomFocus>(fetch(await proxy('StartZoomFocus'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "StartZoomFocus", "action": 0, "param": {"ZoomFocus": {"channel": channel, "op": op, "pos": Number(val)}}}])
    }));
  }
  async function ptzGetPresets() {
    console.debug('Fetching presets');
    return getValue<PtzPreset>(fetch(await proxy('GetPtzPreset'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "GetPtzPreset", "action": 1, "param": {"channel": channel}}])
    }));
  }
  async function ptzGetZoomFocus() {
    console.debug('Fetching ZoomFocus');
    return getValue<ZoomFocus>(fetch(await proxy('GetZoomFocus')));
  }
  async function getAiAlarm(type = 'people') {
    console.debug('Fetching alarm');
    return getValue<AiAlarm>(fetch(await proxy('GetAiAlarm'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "GetAiAlarm", "action": 1, "param": {"channel": channel, "ai_type": type}}])
    }));
  }
  async function setAiAlarm(alarm: AiAlarm) {
    console.debug('Setting alarm');
    return getValue<void>(fetch(await proxy('SetAiAlarm'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "SetAiAlarm", "action": 1, "param": {"channel": channel, ...alarm}}])
    }));
  }
  async function getMask() {
    console.debug('Fetching privacy mask');
    return getValue<unknown>(fetch(await proxy('GetMask'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "GetMask", "action": 1, "param": {"channel": channel}}])
    }));
  }
  async function setMask(mask: Object) {
    console.debug('Setting privacy mask');
    try {
      if ((mask as any).Mask.area === null) (mask as any).Mask.area = [];
    } catch (e) { console.warn(e); }
    return getValue<void>(fetch(await proxy('SetMask'), {
      method: 'POST',
      body: JSON.stringify([{"cmd": "SetMask", "action": 1, "param": {"channel": channel, ...mask}}])
    }));
  }
  return { proxy, login, logout, logoutSync, getValue, ptzAbility, ptzControl, ptzToPos, ptzZoomFocus, ptzGetPresets, ptzGetZoomFocus, getAiAlarm, setAiAlarm, getMask, setMask };
};

